webpackJsonp([262104617495404],{

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n\n  box-shadow: 0 0 10px #454545;\n"], ["\n  ", ";\n\n  box-shadow: 0 0 10px #454545;\n"]);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ShadowImage = _styledComponents2.default.img(_templateObject, function (_ref) {
	  var width = _ref.width;
	
	  if (width) {
	    return "width: " + width;
	  }
	});
	
	exports.default = ShadowImage;
	module.exports = exports["default"];

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dukes.99ce75fe.jpg";

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/flemings-steakhouse.5464468e.jpg";

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hilton-garden-inn.2604e0ff.jpg";

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hilton-inverness.9b48707d.jpg";

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/swan-gardens.d422987f.jpg";

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/yayas.08aaf4c1.jpg";

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex: 1;\n\n  padding: 1rem;\n"], ["\n  flex: 1;\n\n  padding: 1rem;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FlexRow = __webpack_require__(63);
	
	var _FlexRow2 = _interopRequireDefault(_FlexRow);
	
	var _Card = __webpack_require__(62);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ShadowImage = __webpack_require__(46);
	
	var _ShadowImage2 = _interopRequireDefault(_ShadowImage);
	
	var _swanGardens = __webpack_require__(633);
	
	var _swanGardens2 = _interopRequireDefault(_swanGardens);
	
	var _dukes = __webpack_require__(629);
	
	var _dukes2 = _interopRequireDefault(_dukes);
	
	var _flemingsSteakhouse = __webpack_require__(630);
	
	var _flemingsSteakhouse2 = _interopRequireDefault(_flemingsSteakhouse);
	
	var _hiltonGardenInn = __webpack_require__(631);
	
	var _hiltonGardenInn2 = _interopRequireDefault(_hiltonGardenInn);
	
	var _hiltonInverness = __webpack_require__(632);
	
	var _hiltonInverness2 = _interopRequireDefault(_hiltonInverness);
	
	var _yayas = __webpack_require__(636);
	
	var _yayas2 = _interopRequireDefault(_yayas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import maggianos from "../images/maggianos.jpg";
	
	
	var MapContainer = _styledComponents2.default.div(_templateObject);
	
	var WhatsHappeningPage = function WhatsHappeningPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _FlexRow2.default,
	      null,
	      _react2.default.createElement(
	        _Card2.default,
	        { header: "Ceremony", flex: "1" },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "location",
	            href: "http://www3.hilton.com/en/hotels/colorado/hilton-denver-inverness-DENIRHH/index.html",
	            target: "_blank"
	          },
	          "Hilton Denver Inverness"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Saturday, August 18, 2018 - 10:30AM"
	        ),
	        _react2.default.createElement(_ShadowImage2.default, { src: _swanGardens2.default }),
	        _react2.default.createElement(
	          "p",
	          null,
	          "200 Inverness Drive West",
	          _react2.default.createElement("br", null),
	          "Englewood, CO, 80112"
	        )
	      ),
	      _react2.default.createElement(
	        _Card2.default,
	        { header: "Reception", flex: "1" },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "location",
	            href: "https://www.flemingssteakhouse.com/locations/co/englewood/",
	            target: "_blank"
	          },
	          "Fleming's Steakhouse"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Saturday, August 18, 2018 - 12:00PM"
	        ),
	        _react2.default.createElement(_ShadowImage2.default, { src: _flemingsSteakhouse2.default }),
	        _react2.default.createElement(
	          "p",
	          null,
	          "191 Inverness Drive West",
	          _react2.default.createElement("br", null),
	          "Englewood, CO 80112"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _FlexRow2.default,
	      null,
	      _react2.default.createElement(
	        _Card2.default,
	        { header: "Rehearsal Dinner", flex: "1" },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "location",
	            href: "https://dukescastlerock.com/",
	            target: "_blank"
	          },
	          "Duke's Steakhouse"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Friday, August 17, 2018 - 6:00PM"
	        ),
	        _react2.default.createElement(_ShadowImage2.default, { src: _dukes2.default }),
	        _react2.default.createElement(
	          "p",
	          null,
	          "363 Village Square Lane",
	          _react2.default.createElement("br", null),
	          "Castle Pines, CO 80108"
	        )
	      ),
	      _react2.default.createElement(
	        _Card2.default,
	        { header: "Sunday Brunch", flex: "1" },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "location",
	            href: "http://www.yayasdenver.com/",
	            target: "_blank"
	          },
	          "YaYa's Euro Bistro"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Sunday, August 19, 2018 - 10:00AM"
	        ),
	        _react2.default.createElement(_ShadowImage2.default, { src: _yayas2.default, width: "100%" }),
	        _react2.default.createElement(
	          "p",
	          null,
	          "8310 East Belleview Avenue",
	          _react2.default.createElement("br", null),
	          "Greenwood Village, CO 80111"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _FlexRow2.default,
	      null,
	      _react2.default.createElement(
	        _Card2.default,
	        { header: "Accommodations", flex: "1" },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "location",
	            href: "http://group.hiltongardeninn.com/fishmanleewedding",
	            target: "_blank"
	          },
	          "Hilton Garden Inn - Denver South"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Special Rate: $99 per night"
	        ),
	        _react2.default.createElement(_ShadowImage2.default, { src: _hiltonGardenInn2.default }),
	        _react2.default.createElement(
	          "p",
	          null,
	          "9290 Meridian Boulevard",
	          _react2.default.createElement("br", null),
	          "Englewood, CO 80112"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "To make a reservation,",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "http://group.hiltongardeninn.com/fishmanleewedding",
	              target: "_blank"
	            },
	            "click here"
	          ),
	          " ",
	          "or call (303) 824-1550 by July 18, 2018 and request the Fishman-Lee wedding rate."
	        )
	      ),
	      _react2.default.createElement(
	        _Card2.default,
	        { header: "Accommodations", flex: "1" },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "location",
	            href: "http://www3.hilton.com/en/hotels/colorado/hilton-denver-inverness-DENIRHH/index.html",
	            target: "_blank"
	          },
	          "Hilton Denver Inverness"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Special Rate: $149 per night"
	        ),
	        _react2.default.createElement(_ShadowImage2.default, { src: _hiltonInverness2.default }),
	        _react2.default.createElement(
	          "p",
	          null,
	          "200 Inverness Drive West",
	          _react2.default.createElement("br", null),
	          "Englewood, CO 80112"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "To make a reservation,",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://bit.ly/2GCJ1hv", target: "_blank" },
	            "click here"
	          ),
	          " ",
	          "or call (303) 799-5800 by July 18, 2018 and request the Fishman-Lee wedding rate."
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Card2.default,
	      { header: "Map of Locations", flex: "1" },
	      _react2.default.createElement(
	        MapContainer,
	        null,
	        _react2.default.createElement("iframe", {
	          src: "https://www.google.com/maps/d/embed?mid=1wPrlO0cUcgRooReSZIsw_KsoVSmBo7ut&hl=en",
	          width: "100%",
	          height: "650"
	        })
	      )
	    )
	  );
	};
	
	exports.default = WhatsHappeningPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-whats-happening-js-a4dae51741a76ed2dfc8.js